import $ from 'jquery';

class _YandexEcommerce {
    constructor() {
        window.dataLayer = window.dataLayer || [];
        this._handleCatalogDetail();
    }

    basket = (id, name, price, _quantity) => {
        const quantity = +_quantity;
        window.dataLayer.push({
            'ecommerce': {
                'remove': {
                    'products': [
                        {
                            id,
                            name,
                            price: +price,
                            quantity: +quantity
                        }
                    ]
                }
            }
        });
        if (quantity > 0) {
            window.dataLayer.push({
                'ecommerce': {
                    'add': {
                        'products': [
                            {
                                id,
                                name,
                                price: +price,
                                quantity: +quantity
                            }
                        ]
                    }
                }
            });
        }
    };

    purchase = (products) => {
        window.dataLayer.push({
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': Date.now()
                    },
                    'products': products
                }
            }
        });
    };

    _handleCatalogDetail = () => {
        if ($('.catalog-detail').length === 0) {
            return;
        }

        const data = {
            'ecommerce': {
                'detail': {
                    'products': [
                        {
                            'id': $('.catalog-detail__article span').text().trim(),
                            'name': $('.catalog-detail__title').first().text().trim(),
                            'price': parseFloat($('.catalog-detail-purchase__price').text().trim())
                        }
                    ]
                }
            }
        };

        window.dataLayer.push(data);
    };
}


const YandexEcommerce = new _YandexEcommerce();
export default YandexEcommerce;
